import React from "react";
import PropTypes from "prop-types";
import { getShiftPillVisuals } from "./shiftCardColors";

/**
 * Cabecera tipo pill del listado /shifts (misma marca que ShiftCard).
 */
const ShiftPill = ({ name, color, periodsLabel, className = "" }) => {
	const { pillOnWhite, style } = getShiftPillVisuals(color);

	return (
		<div
			className={`shift-card__pill${
				pillOnWhite ? " shift-card__pill--on-white" : ""
			}${className ? ` ${className}` : ""}`.trim()}
			style={style}
		>
			<span className="shift-card__pill-name">{name}</span>
			{periodsLabel ? (
				<span className="shift-card__pill-periods"> {periodsLabel}</span>
			) : null}
		</div>
	);
};

ShiftPill.propTypes = {
	name: PropTypes.string.isRequired,
	color: PropTypes.string,
	periodsLabel: PropTypes.string,
	className: PropTypes.string,
};

ShiftPill.defaultProps = {
	color: "",
	periodsLabel: "",
	className: "",
};

export default ShiftPill;
